import React from 'react';

const FloatingElements = () => {
  const shapes = [
    { size: 100, delay: 0, duration: 20, left: '10%', top: '20%' },
    { size: 80, delay: 2, duration: 25, left: '80%', top: '60%' },
    { size: 120, delay: 4, duration: 30, left: '70%', top: '10%' },
    { size: 60, delay: 1, duration: 22, left: '20%', top: '70%' },
    { size: 90, delay: 3, duration: 28, left: '50%', top: '40%' },
  ];

  return (
    <div className="floating-elements-container">
      {shapes.map((shape, index) => (
        <div
          key={index}
          className="floating-shape"
          style={{
            width: `${shape.size}px`,
            height: `${shape.size}px`,
            left: shape.left,
            top: shape.top,
            animationDelay: `${shape.delay}s`,
            animationDuration: `${shape.duration}s`,
          }}
        >
          <div className="floating-shape-inner" />
        </div>
      ))}
    </div>
  );
};

export default FloatingElements;